import { useEffect } from "react";
import { siteMeta } from "../content/site";

interface MetaOptions {
  title: string;
  description: string;
}

const upsertMeta = (selector: string, attributes: Record<string, string>) => {
  const existing = document.head.querySelector<HTMLMetaElement>(selector);
  const tag = existing || document.createElement("meta");

  Object.entries(attributes).forEach(([key, value]) => {
    tag.setAttribute(key, value);
  });

  if (!existing) {
    document.head.appendChild(tag);
  }
};

export const useDocumentMeta = ({ title, description }: MetaOptions) => {
  useEffect(() => {
    document.title = `${title} | ${siteMeta.name}`;

    upsertMeta('meta[name="description"]', { name: "description", content: description });
    upsertMeta('meta[property="og:title"]', { property: "og:title", content: `${title} | ${siteMeta.name}` });
    upsertMeta('meta[property="og:description"]', { property: "og:description", content: description });
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: `${title} | ${siteMeta.name}` });
    upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });

    const canonicalHref = `${window.location.origin}${window.location.pathname}`;
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');

    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }

    link.href = canonicalHref;
  }, [description, title]);
};
